import _ from "lodash";
import i18n from "@/localization/localization.js";
const $t = (key, params) => i18n.global.t(key, params);
let defaultStore;
getDefaultStore();
export const scope = {
    testRole: "testRole",
    stackingPool: "stackingPool",
    enableReferralSystem: "enableReferralSystem",
    kycComplete: "kycComplete",
    kycLimitsEnabled: "kycLimitsEnabled",
    deposit: "deposit",
    withdrawal: "withdrawal",
    notAutentic: "notAutentic",
    notRwa: "notRwa",
    notFintechpark: "notFintechpark",
    notRotunda: "notRotunda"
};
function getDefaultStore() {
    if (defaultStore) {
        return defaultStore;
    }
    try {
        if (window.__HISTOIRE__) {
            import("@/components/uikit/histoire.store").then(storeModule => {
                defaultStore = storeModule.createHistoireStore({});
            }).catch();
        }
        else {
            import("@/store").then(storeModule => {
                defaultStore = storeModule.default;
            }).catch();
        }
    }
    catch (error) {
        console.error("Error get store:", error);
    }
}
export function checkPostfix() {
    switch (process.env.VUE_APP_VENDOR) {
        case "autentic":
            return "";
        case "rwaTown":
            return "Rwa";
        case "rotunda":
            return "Rotunda";
        case "fintechpark":
            return "Fintechpark";
        default:
            return "";
    }
}
export function checkAccess(value, store) {
    // Эти проверки вынесены отдельно, так как не зависят от данных пользователя и могут использоваться в разных местах, где store может быть недоступен.
    switch (value) {
        case scope.notAutentic:
            return process.env.VUE_APP_VENDOR != "autentic";
        case scope.notRwa:
            return process.env.VUE_APP_VENDOR != "rwaTown";
        case scope.notRotunda:
            return process.env.VUE_APP_VENDOR != "rotunda";
        case scope.notFintechpark:
            return process.env.VUE_APP_VENDOR != "fintechpark";
        case scope.enableReferralSystem:
            return /true/i.test(process.env.VUE_APP_ENABLE_REFERRAL_SYSTEM || "");
    }
    if (!store) {
        store = defaultStore;
    }
    if (!store || !store.getters) {
        console.error("Store не найден. Передайте store первым аргументом или убедитесь, что Vuex инициализирован.");
        return false;
    }
    const ethAddresses = store.getters["ethAddresses"];
    const address = _.get(ethAddresses, "[0]", "");
    switch (value) {
        case scope.testRole:
            return store.getters["profile/isTestRole"];
        case scope.stackingPool:
            return store.getters["profile/isTestRole"];
        case scope.deposit:
            if (checkAccess(scope.kycLimitsEnabled, store)) {
                return store.getters["profile/profile"]?.isConfirmed &&
                    address?.verifiedAt &&
                    address?.status &&
                    checkAccess(scope.kycComplete, store);
            }
            else {
                return store.getters["profile/profile"]?.isConfirmed &&
                    address?.verifiedAt &&
                    address?.status;
            }
        case scope.withdrawal:
            return !checkAccess(scope.notRwa, store) && store.getters["profile/profile"]?.is2FaEnabled;
        case scope.kycComplete:
            return store.getters["profile/profile"]?.kycStatus === "completed";
        case scope.kycLimitsEnabled:
            return /true/i.test(store.getters["apiSystemSettings"]?.kycLimitsEnabled);
        default:
            return false;
    }
}
export const reasons = {
    email: "email",
    wallet: "wallet",
    kyc: "kyc",
    turnOn2Fa: "turnOn2Fa"
};
export function getAccessDeniedReasons(value, store) {
    if (!store) {
        store = defaultStore;
    }
    if (!store || !store.getters) {
        return [];
    }
    const ethAddresses = store.getters["ethAddresses"];
    const address = _.get(ethAddresses, "[0]", "");
    let ret = [];
    switch (value) {
        case scope.deposit:
            if (!store.getters["profile/profile"]?.isConfirmed && !address?.verifiedAt && !address?.status) {
                ret = [reasons.email, reasons.wallet];
            }
            else if (!store.getters["profile/profile"]?.isConfirmed) {
                ret = [reasons.email];
            }
            else if (!address?.verifiedAt && !address?.status) {
                ret = [reasons.wallet];
            }
            return ret;
        case scope.withdrawal:
            if (!checkAccess(scope.notRwa, store) && !store.getters["profile/profile"]?.is2FaEnabled) {
                ret = [reasons.turnOn2Fa];
            }
            return ret;
        default:
            return [];
    }
}
export function getAccessDeniedReasonsText(value, params, store) {
    if (!store) {
        store = defaultStore;
    }
    if (!store || !store.getters) {
        return "";
    }
    const denyReasons = getAccessDeniedReasons(value, store);
    if (value == scope.deposit) {
        const hasEmailProblem = denyReasons.includes(reasons.email);
        const hasWalletProblem = denyReasons.includes(reasons.wallet);
        const hasKycProblem = denyReasons.includes(reasons.kyc);
        let reasonKey = "";
        if (hasEmailProblem && hasWalletProblem) {
            reasonKey = checkAccess(scope.notRwa) ? "emailAndWalletVerify" : "emailAndWalletVerifyRwa";
        }
        else if (hasEmailProblem) {
            reasonKey = "emailVerify";
        }
        else if (hasWalletProblem) {
            reasonKey = checkAccess(scope.notRwa) ? "walletVerify" : "walletVerifyRwa";
        }
        if (hasKycProblem) {
            reasonKey = reasonKey ? reasonKey + "Kyc" : "kycDenied";
        }
        return reasonKey ? $t(`access.reasons.${reasonKey}`, params) : "";
    }
    if (value == scope.withdrawal && denyReasons.includes(reasons.turnOn2Fa)) {
        return $t("access.reasons.turnOn2Fa", params);
    }
    return "";
}
